import Vue from "vue";
import "babel-polyfill";
import App from "./App.vue";
import Numeral from "numeral";
import Decimal from "decimal.js";
import VueMeta from "vue-meta";
import pagination from "vuejs-uib-pagination";
import VueGtm from "@gtm-support/vue2-gtm";
import { bnCode } from "./util/binance";

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/ko";
import "element-ui/lib/theme-chalk/index";
// import "./styles/element-variables.scss";

import "./global.scss";
import "./custom.scss";
// Import Vuesax(UI Framework)
import Vuesax from "vuesax";
import "vuesax/dist/vuesax"; //Vuesax styles
import "material-icons/iconfont/material-icons";

import _ from "lodash";

// Import Dexko Vuex(Global State Storage) Stores Import Dexko Page Routers
import VueRouter from "vue-router";
import router from "./routes";
import store from "./store";
import Plugins from "./common/Plugins.ts";
import VueCarousel from "vue-carousel";
var VueCookie = require("vue-cookie");
import i18n from "./i18n";
import { gradeArr } from "./util/grade_json";

document.domain;
if (process.env.NODE_ENV === "development") {
  window.debugMode = true;
} else {
  //#region 전역 설정
  document.domain = location.host.replace("m.", "", );
}

Vue.prototype.$isDevServer = !(
  _.includes(window.location.href, "https://m.flybit.com") ||
  _.includes(window.location.href, "https://m.v1.flybit.com")
);

Vue.use(VueGtm, {
  id: "GTM-PB3RLG8", // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

Vue.use(Vuesax);
Vue.use(VueRouter);
Vue.use(Plugins);
Vue.use(VueCarousel);
Vue.use(VueCookie);
Vue.use(VueMeta);
Vue.use(ElementUI, { locale });
Vue.use(pagination);
Vue.filter("rbClass", function(value) {
  const red = "txt-red";
  const blue = "txt-blue";
  if (value > 0) {
    return red;
  } else if (value < 0) {
    return blue;
  } else {
    return "txt-black";
  }
});
Vue.filter("caret", function(value) {
  const up = "arrow_drop_up";
  const down = "arrow_drop_down";
  if (value > 0) {
    return up;
  } else if (value < 0) {
    return down;
  } else {
    return "remove";
  }
});
// 자산현황 소액자산 hidden 클래스 붙이기
Vue.filter("hiddenClass", function(value, checked = false) {
  if (value < 1000 && checked) {
    return "hidden";
  } else {
    return "";
  }
});
//#region custom global filters
Vue.filter("formatNumber", function(value = 0, fixed = 0, format) {
  if (typeof fixed === "string") {
    fixed = fixed === "KRW" ? 0 : 8;
  }
  value = parseFloat(value || 0);
  const formatStr = "0,0[.]" + _.repeat("0", fixed);
  if (value === false) {
    return 0;
  }
  if (!format && fixed > 0) {
    const fixedStr = Decimal(value)
      .toFixed(fixed)
      .split(".");
    if (fixedStr.length !== 2) {
      return value;
    }
    return (
      Numeral(fixedStr[0]).format("0,0") +
      "." +
      fixedStr[1] +
      _.repeat("0", fixed - fixedStr[1].length)
    );
  }
  const result = Numeral(Decimal(value).toFixed(fixed || 0)).format(
    format || formatStr
  ); // displaying other groupings/separators is possible, look at the docs
  return result;
});

//소수점 해당 자릿수까지 노출 및 이하 절삭
Vue.filter("formatNumber2", function(value = 0, fixed = 0, format) {
  if (typeof fixed === "string") {
    fixed = fixed === "KRW" ? 0 : 8;
  }
  value = parseFloat(value || 0);
  const formatStr = "0,0[.]" + _.repeat("0", fixed);
  if (value === false) {
    return 0;
  }
  if (!format && fixed > 0) {
    const fixedStr = Decimal(value)
      .toFixed(fixed, Decimal.ROUND_DOWN)
      .split(".");
    if (fixedStr.length !== 2) {
      return value;
    }
    return (
      Numeral(fixedStr[0]).format("0,0") +
      "." +
      fixedStr[1] +
      _.repeat("0", fixed - fixedStr[1].length)
    );
  }
  const result = Numeral(Decimal(value).toFixed(fixed || 0)).format(
    format || formatStr
  ); // displaying other groupings/separators is possible, look at the docs
  return result;
});

//#region custom global filters 원화 백만 단위 이하 절사
Vue.filter("formatNumber3", function(value = 0, fixed = 0, format) {
  fixed = Math.floor(fixed);
  value = parseFloat(value || 0);
  const formatStr = "0,0[.]" + _.repeat("0", fixed); // 0,0.0000 -> 소수 표기법
  const fixedStr = Decimal(value)
    .toFixed(fixed)
    .split("."); //fixed 반올림. 소수점 양 옆으로 쪼갬
  if (value === false || value == 0) {
    return 0; //value가 false거나 0이면 0으로 리턴
  }
  if (fixedStr.length !== 2) {
    //백만 이상 단위일 때
    if (fixedStr[0].length > 6) {
      const millionText = fixedStr[0].length - 6;
      const millionFormat = String(value).substring(0, millionText);
      return (
        Numeral(millionFormat).format("0,0") + i18n.t("trade.millionPriceKo")
      );
    } else if (fixedStr[0].length <= 6) {
      return Numeral(fixedStr[0]).format("0,0");
    }
    return value;
  }
  const result = Numeral(Decimal(value).toFixed(fixed || 0)).format(
    format || formatStr
  ); // displaying other groupings/separators is possible, look at the docs
  return result;
});

//소수점 절사. 정수만 노출. 자산현황 페이지 KRW 단위에만 적용
Vue.filter("formatNumber4", function(value = 0) {
  value = parseFloat(value || 0);
  return Numeral(Math.floor(value)).format("0,0");
});

//플러스 앞에 +노출. 자산현황 페이지에만 적용
Vue.filter("formatNumber5", function(value = 0, fixed = 0, format) {
  fixed = Math.round(fixed);
  value = parseFloat(value || 0);
  const formatStr = "0,0[.]" + _.repeat("0", fixed);
  if (value === false || value == 0) {
    return 0;
  }
  if (!format && fixed > 0) {
    const fixedStr = Decimal(value)
      .toFixed(fixed)
      .split(".");
    if (fixedStr.length !== 2) {
      return value;
    }
    if (value > 0) {
      return (
        "+" +
        Numeral(fixedStr[0]).format("0,0") +
        "." +
        fixedStr[1] +
        _.repeat("0", fixed - fixedStr[1].length)
      );
    } else if ((value < 0, value > -1)) {
      "-" +
        Numeral(fixedStr[0]).format("0,0") +
        "." +
        fixedStr[1] +
        _.repeat("0", fixed - fixedStr[1].length);
    } else {
      return (
        Numeral(fixedStr[0]).format("0,0") +
        "." +
        fixedStr[1] +
        _.repeat("0", fixed - fixedStr[1].length)
      );
    }
  }
  const result = Numeral(Decimal(value).toFixed(fixed || 0)).format(
    format || formatStr
  ); // displaying other groupings/separators is possible, look at the docs
  return result;
});

//소수점 절사. 정수만 노출. 자산현황 페이지 KRW 단위에만 적용. 플러스 추가
Vue.filter("formatNumber6", function(value = 0) {
  value = parseFloat(value || 0);
  if (value > 0) {
    return "+" + Numeral(Math.floor(value)).format("0,0");
  } else {
    return Numeral(Math.floor(value)).format("0,0");
  }
});

Vue.filter("formatNumberAuto", function(value) {
  return new Intl.NumberFormat().format(value);
});

Vue.filter("withSign", function(
  value,
  { formatted, isDecimal = false, fixed = 8 }
) {
  value = Numeral(value).value();
  if (!_.isNumber(value)) {
    return "";
  }

  let result = "";
  if (isDecimal) {
    const formatStr = _.repeat("0", fixed);
    result = formatted
      ? Numeral(value).format("0,0[.]" + formatStr)
      : value.fixed(fixed);
  } else {
    result = formatted ? Numeral(value).format("0,0") : value;
  }
  return value < 0 ? result : `+${result}`;
});

Vue.filter("toPerc", function(value) {
  return Decimal(value).mul(100) + "%";
});

Vue.filter("volumeFormatter", function(volume, minTrade) {
  let format = "0,0.";
  if (minTrade.toString().split(".").length > 1) {
    for (var i = 0; i < minTrade.toString().split(".")[1].length; i++) {
      format += 0;
    }
  }
  return Numeral(volume).format(format);
});

Vue.filter("base64", function(str) {
  // 이미지가 base64인지 url인지 판단
  try {
    const isBase64 = btoa(atob(str)) == str;
    if (!isBase64) {
      throw new Error("not base64");
    }
    return `data:image/jpg;base64,${str}`;
  } catch (e) {
    return str;
  }
});

Vue.prototype.$isDevServer = !(
  _.includes(window.location.href, "/m.flybit.com") ||
  _.includes(window.location.href, "/m.v1.flybit.com")
);

Vue.prototype.$deviceType = function() {
  const agent = navigator.userAgent;
  if (agent.indexOf("iPhone") > 0) {
    return "410";
  } else if (agent.indexOf("Android") > 0) {
    return "430";
  }
};

//바이낸스 코인코드인지 확인하는 부분
Vue.prototype.$bnCode = (code) => {
  return bnCode(code);
};

// 랭킹데이터
Vue.prototype.$level = (level) => {
  if (level > 7) {
    return gradeArr[0];
  }
  return gradeArr.find((grade) => grade.id === level);
};

Vue.prototype.$chart = Vue.prototype.$isDevServer
  ? "https://chart.dev.flybit.com"
  : "https://chart.flybit.com";

new Vue({
  router,
  store,
  i18n,
  el: "#app",
  render: (h) => {
    return h(App)
  },
});
